/*  Shared  */
import { Helpers } from 'application/Shared/Helpers';

/* hooks */
import { useFetchTenantProvider } from 'hooks/dataAccess/Tenant/Provider/tenantProvider';
import { useSession } from 'hooks/redux/Selectors/session';

/*  React  */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

export const AdminProvider = ({ component }) => {
    const session = useSession();
    const { clientId } = useParams();
    const { loading, providerConfig } = useFetchTenantProvider(clientId);
    const [providerRoute, setProviderRoute] = useState(null);
    const [translationProvider, setTranslationProvider] = useState(null);

    useEffect(() => {
        if (Helpers.isGoogleEnabledDeployment(providerConfig)) {
            setProviderRoute('google');
            setTranslationProvider('GoogleConfiguration');
        } else if (
            Helpers.isMicrosoftEntraIDEnabledDeployment(providerConfig)
        ) {
            setProviderRoute('azure');
            setTranslationProvider('MicrosoftConfiguration');
        }
    }, [providerConfig]);

    const C = component;

    return !loading && providerRoute && session ? (
        <C
            clientId={clientId}
            providerRoute={providerRoute}
            session={session}
            translationProvider={translationProvider}
        />
    ) : null;
};
